//register plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ScrollSmoother, SplitText);
let globalAnimation = {
  stickyProductForm: function (e) {
    var i = 1;
    window.onscroll = function () {
      var elem = document.querySelector("#product-form");
      var stickyFormContainer = document.querySelector("#sticky-form-wrapper");
      if (elem != null && stickyFormContainer != null) {
        var isOutOfViewport = function (elem) {
          // Get element's bounding
          var bounding = elem.getBoundingClientRect();
          var stickyHeight =
            document.querySelector("#product-form form").offsetHeight;
          var bottom = bounding.bottom + stickyHeight - 100;
          // Check if it's out of the viewport on each side
          var out = {};
          out.topOffset = bounding.top;
          out.top = bounding.top < 0;
          out.left = bounding.left < 0;
          out.bottom =
            bottom >
            (window.innerHeight || document.documentElement.clientHeight);
          out.right =
            bounding.right >
            (window.innerWidth || document.documentElement.clientWidth);
          out.any = out.top || out.left || out.bottom || out.right;
          out.all = out.top && out.left && out.bottom && out.right;
          return out;
        };
        var isOut = isOutOfViewport(elem);
        var item = document.querySelector("#sticky-form-wrapper");
        var item2 = document.querySelector("#shopify-section-primary-nav");

        var stickyHeight1 = item2.offsetHeight;
        var stickyHeight2 = item.offsetHeight + 1;

        // console.log('sticky header height', stickyHeight2)

        if (isOut.topOffset <= 0 || isOut.bottom == false) {
          if (item != null) {
            item.style.setProperty("will-change", "transform, opacity");
            var width = window.innerWidth;
            if(document.querySelector('.main-header-sticky') != null) {
              if (width >= 1008) {
                // item.style.setProperty("top", `${stickyHeight2}px`);
                // item.style.setProperty("top", `75px`);
                item.style.setProperty("top", `${stickyHeight1}px`);
              } else {
                var navbar = document.querySelector(".primary-mobile-nav");
                if (navbar != null) {
                  stickyHeight2 = navbar.offsetHeight;
                }
                item.style.setProperty("top", `${stickyHeight2 + 0}px`);
              }
            } else {
              item.style.setProperty("top", `0px`);
            }
            stickyFormContainer.classList.add("sticky-form-product");
          }
        } else {
          removeStickyClassOnScrollTop(
            "sticky-form-product",
            document.getElementById("sticky-form-wrapper")
          );
        }
      }
    };
    function removeStickyClassOnScrollTop(className, element) {
      window.addEventListener("scroll", function () {
        if (window.scrollY === 0) {
          if (element) {
            element.classList.remove(className);
            document
              .querySelector("#sticky-form-wrapper")
              .style.setProperty("top", "0px");
          } else {
            return;
          }
        }
      });
    }
  },
  animationEffects: function (e) {
    // 1 - loading
    if (document.querySelector(".loading-panels") != null) {
      const loader = gsap.timeline({
        paused: true,
      });
      loader
        .to(
          ".loading-panels .loading-panel:first-child, .loading-panels .loading-panel:last-child",
          {
            scaleY: 1,
            duration: 1,
          }
        )
        .to(
          ".loading-panels .loading-panel:not(:first-child):not(:last-child)",
          {
            scaleY: 1,
          },
          "-=0.5"
        )
        .to(".loading-panels .loading-panel", {
          scaleY: 0,
          duration: 0.3,
          stagger: 0.05,
        })
        .to(".loading-panels", {
          clipPath: "circle(0%)",
          skewX: 0,
          duration: 1,
        })
        .to(
          ".atom-theme",
          {
            clipPath: "(100%)",
            duration: 1,
          },
          "-=0.3"
        );
      window.addEventListener("load", function () {
        loader.play();
      });
      window.addEventListener("resize", function () {
        if (document.querySelector(".loading-panels") != null) {
          document.querySelector(".loading-panels").style.display = "none";
        }
      });
    }
    // 2 - animate sections
    if (document.body.getAttribute("id") != "product") {
      if (document.body.getAttribute("id") != "collection") {
        var shopifySections = gsap.utils.toArray(".shopify-section");
        if (shopifySections != null) {
          gsap.set(".shopify-section", {
            clearProps: true,
          });
          gsap.set(shopifySections, {
            //className: "animation-applied-element",
          });
          ScrollTrigger.matchMedia({
            "(min-width: 1008px)": function () {
              shopifySections.forEach((sectionItem, i) => {
                sectionItem.classList.add("animation-applied-element");
                if (
                  sectionItem.querySelector("header") == null &&
                  sectionItem.querySelector(".main-footer") == null &&
                  sectionItem.querySelector(".footer-newsletter") == null
                ) {
                  var anim1 = gsap.fromTo(
                    sectionItem,
                    {
                      autoAlpha: 0,
                      y: 150,
                    },
                    {
                      duration: 1,
                      autoAlpha: 1,
                      y: 0,
                    }
                  );
                  ScrollTrigger.create({
                    trigger: sectionItem,
                    animation: anim1,
                    start: "top 100%",
                    end: "top 50%",
                    markers: false,
                    scrub: 1.5,
                  });
                }
              });
            },
          });
        }
      }
    }
    //3 - welcome text animation
    if (document.querySelector(".js-section-title") != null) {
      gsap.set(".js-section-title", {
        clearProps: true,
      });
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {
          let welcomeText = gsap.utils.toArray(".js-section-title");
          const sectionTitle = gsap.timeline({
            scrollTrigger: {
              trigger: welcomeText,
              start: "top 90%",
              end: "bottom 60%",
              scrub: 2,
              markers: false,
              toggleActions: "play none play reset",
            },
          });
          const welcomeSplit = new SplitText(welcomeText, {
            type: "lines",
          });
          sectionTitle.from(welcomeSplit.lines, {
            y: 100,
            opacity: 0,
            stagger: 0.05,
            duration: 0.5,
            ease: "back.inOut",
          });
        },
      });
    }
    //4 - product description animation
    if (
      document.querySelector(".section-product-tabs") != null &&
      Shopify.designMode != true
    ) {
      let splitTextLines = gsap.utils.toArray(".product-overview__text");
      gsap.set(".product-overview__text", {
        clearProps: true,
      });
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: splitTextLines,
              start: "top 90%",
              end: "top 20%",
              scrub: 2,
              markers: false,
              toggleActions: "play none play reset",
            },
          });
          const itemSplitted = new SplitText(splitTextLines, {
            type: "lines",
          });
          tl.from(itemSplitted.lines, {
            y: 100,
            opacity: 0,
            stagger: 0.05,
            duration: 0.5,
            ease: "back.inOut",
          });
        },
      });
    }
    // 5 - product page scroll effect media
    if (document.body.getAttribute("id") == "product") {
      var addHeight = 0;
      if (e.type == "shopify:section:load") {
        addHeight = document.querySelector("#product-info").offsetHeight;
        console.log(addHeight);
      }
      if (e.type == "click") {
        addHeight = document.querySelector("#product-info").offsetHeight;
      }
      gsap.set("#product-media", {
        clearProps: true,
      });
      gsap.set("#product-info", {
        clearProps: true,
      });
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {
          var section = document.querySelector("#product-media");
          var anim = gsap.fromTo(
            section,
            {
              y: 10,
            },
            {
              duration: 0.5,
              y: 0,
              ease: "power4.out",
            }
          );
          ScrollTrigger.create({
            trigger: section,
            animation: anim,
            top: "top 0%",
            end: (self) =>
              "+=" +
              (document.querySelector("#product-media").offsetHeight -
                addHeight -
                self.pin.offsetHeight),
            pin: "#product-info",
            onRefresh: (self) => (self.pin.parentNode.style.float = "left"),
            pinSpacing: false,
            anticipatePin: 1,
            markers: false,
            scrub: 2,
          });
        },
      });
      // 6 - scrolltrigger for each section
      var sections = gsap.utils.toArray(".shopify-section");
      if (sections != null) {
        gsap.set(".shopify-section", {
          clearProps: true,
        });
        sections.forEach((section, i) => {
          if (
            section.querySelector("#product-form") == null &&
            section.querySelector(".shopify-section-group-footer-group") !=
              null &&
            section.querySelector("header") == null
          ) {
            ScrollTrigger.matchMedia({
              "(min-width: 768px)": function () {
                var anim = gsap.fromTo(
                  section,
                  {
                    autoAlpha: 0,
                    y: 150,
                  },
                  {
                    duration: 1,
                    autoAlpha: 1,
                    y: 0,
                  }
                );
                ScrollTrigger.create({
                  trigger: section,
                  animation: anim,
                  start: "top 100%",
                  end: "top 60%",
                  markers: false,
                  scrub: 1.5,
                });
              },
            });
          }
        });
      }
    }
    // 7 - Entire site scroll
    if (
      document.querySelector(".main-container") != null &&
      document.querySelector(".main-sidebar") != null
    ) {
      gsap.set(".main-container", {
        clearProps: true,
      });
      gsap.set(".main-sidebar", {
        clearProps: true,
      });
      ScrollTrigger.matchMedia({
        "(min-width: 1008px)": function () {
          let triggers = ScrollTrigger.getAll();
          triggers.forEach((trigger) => {
            var triggers = trigger.vars.trigger;
            if (triggers == ".main-container") {
              trigger.kill();
            }
          });
          gsap.set(".main-sidebar .left-side", {
            x: 0,
          });
          gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
          ScrollSmoother.create({
            content: ".main-container",
            smooth: 2,
            effects: false,
            smoothTouch: 1.5,
          });
          ScrollTrigger.create({
            trigger: ".main-container",
            start: "top top",
            end: "bottom+=1000% bottom",
            pin: ".main-sidebar",
            anticipatePin: 1,
            normalizeScroll: true,
            pinSpacing: false,
            markers: false,
          });
          if (document.querySelector(".main-header-sticky") != null) {
            ScrollTrigger.create({
              trigger: ".main-container",
              start: "top top",
              pin: ".main-header-sticky",
              anticipatePin: 1,
              normalizeScroll: true,
              pinSpacing: false,
              markers: false,
            });
          }
        },
      });
    }
    // flicker debugger
    window.addEventListener("load", (event) => {
      var flickerSelectors = [
        ".main-sidebar",
        ".collection-sorting.filter-wrapper",
        "#product-info",
        ".main-header-sticky",
        ".product-grid",
        "#page-cart",
      ];
      flickerSelectors.forEach(function (sl, index) {
        var item = document.querySelector(sl);
        console.log("loading js", item);
        if (item != null) {
          item.style.setProperty("will-change", "transform, opacity");
        }
      });
    });
    window.addEventListener("load", (event) => {
      var productImgDsk = [".product-media-desktop-only"];
      productImgDsk.forEach(function (item, index) {
        var productItem = document.querySelector(item);
        console.log("loading js", productItem);
        if (productItem != null) {
          productItem.style.setProperty("will-change", "transform, opacity");
        }
      });
    });
  },
};
//events
if (Shopify.designMode != true) {
  document.addEventListener("DOMContentLoaded", function (e) {
    globalAnimation.animationEffects(e);
    if(window.theme.stickyHeader){
      globalAnimation.stickyProductForm(e);
    }
  });
  document.addEventListener("shopify:section:load", function (e) {
    globalAnimation.animationEffects(e);
    if(window.theme.stickyHeader){
      globalAnimation.stickyProductForm(e);
    }
  });
  document.addEventListener("shopify:section:unload", function (e) {
    globalAnimation.animationEffects(e);
    if(window.theme.stickyHeader){
      globalAnimation.stickyProductForm(e);
    }
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    globalAnimation.animationEffects(e);
    if(window.theme.stickyHeader){
      globalAnimation.stickyProductForm(e);
    }
  });
  document.addEventListener("DOMContentLoaded", function () {
    var checkbox = document.querySelector(".RecipientCheckbox");
    if (checkbox != null) {
      checkbox.addEventListener("click", function (e) {
        globalAnimation.animationEffects(e);
        if(window.theme.stickyHeader){
          globalAnimation.stickyProductForm(e);
        }
      });
    }
  });
}
if (Shopify.designMode == true) {
  if (document.querySelector("#product-info") != null) {
    var infoWrapWidth = document.querySelector("#product-info").offsetWidth;
    document.onscroll = function (e) {
      stickyProductMediaSection();
      if(window.theme.stickyHeader){
        globalAnimation.stickyProductForm(e);
      }
    };
    document.addEventListener("shopify:section:load", function (e) {
      if(window.theme.stickyHeader){
        globalAnimation.stickyProductForm(e);
      }
    });
    function stickyProductForm() {
      var i = 1;
      var elem = document.querySelector("#product-form .add-to-cart-button");
      var stickyFormContainer = document.querySelector("#sticky-form-wrapper");
      if (elem != null && stickyFormContainer != null) {
        var isOutOfViewport = function (elem) {
          // Get element's bounding
          var bounding = elem.getBoundingClientRect();
          var stickyHeight =
            document.querySelector("#product-form form").offsetHeight;
          var bottom = bounding.bottom + stickyHeight - 100;
          // Check if it's out of the viewport on each side
          var out = {};
          out.topOffset = bounding.top;
          out.top = bounding.top < 0;
          out.left = bounding.left < 0;
          out.bottom =
            bottom >
            (window.innerHeight || document.documentElement.clientHeight);
          out.right =
            bounding.right >
            (window.innerWidth || document.documentElement.clientWidth);
          out.any = out.top || out.left || out.bottom || out.right;
          out.all = out.top && out.left && out.bottom && out.right;
          return out;
        };
        var isOut = isOutOfViewport(elem);
        if (isOut.topOffset <= 0 || isOut.bottom == false) {
          var item = document.querySelector("#sticky-form-wrapper");
          if (item != null) {
            item.style.setProperty("will-change", "transform, opacity");
            stickyFormContainer.classList.add("sticky-form-product");
          }
        } else {
          stickyFormContainer.classList.remove("sticky-form-product");
        }
      }
    }
    function stickyProductMediaSection() {
      var mediaWrap = document.querySelector("#product-media");
      var infoWrap = document.querySelector("#product-info");
      if (mediaWrap != null && infoWrap != null) {
        var row = infoWrap.closest(".row");
        if (window.innerWidth > 767) {
          var hm = mediaWrap.offsetHeight;
          var hi = infoWrap.offsetHeight;
          var diffmi = hm - hi;
          if (hm > hi) {
            infoWrap.style.position = "fixed";
            infoWrap.style.setProperty("width", infoWrapWidth + "px", "");
            var rect = mediaWrap.getBoundingClientRect();
            var scrolledMedia = -rect.top;
            console.log(scrolledMedia, diffmi);
            if (scrolledMedia >= diffmi) {
              infoWrap.style.position = "relative";
              row.style.setProperty("align-items", "end", "");
              infoWrap.style.removeProperty("top");
            } else if (scrolledMedia < diffmi) {
              infoWrap.style.position = "fixed";
              row.style.removeProperty("align-items");
              infoWrap.style.setProperty("top", "0", "");
            }
            if (Math.sign(scrolledMedia) == -1) {
              infoWrap.style.position = "relative";
              row.style.removeProperty("align-items");
              infoWrap.style.removeProperty("top");
              infoWrap.style.removeProperty("width");
            }
          }
        } else {
          infoWrap.style.position = "relative";
          row.style.removeProperty("align-items");
          infoWrap.style.removeProperty("top");
          infoWrap.style.removeProperty("width");
        }
      }
    }
  }
  // sticky header on theme editor
  window.addEventListener("scroll", function (e) {
    var stickyContainer = document.querySelector(".main-header-sticky");
    var elem = document.querySelector(".index-sidebar-navigation");
    if (elem != null && stickyContainer != null) {
      var isOutOfViewport = function (elem) {
        // Get element's bounding
        var bounding = elem.getBoundingClientRect();
        var bottom = bounding.bottom;
        // Check if it's out of the viewport on each side
        var out = {};
        out.topOffset = bounding.top;
        out.top = bounding.top < 0;
        out.left = bounding.left < 0;
        out.bottom =
          bottom >
          (window.innerHeight || document.documentElement.clientHeight);
        out.right =
          bounding.right >
          (window.innerWidth || document.documentElement.clientWidth);
        out.any = out.top || out.left || out.bottom || out.right;
        out.all = out.top && out.left && out.bottom && out.right;
        return out;
      };
      var isOut = isOutOfViewport(elem);
      console.log(isOut);
      if (isOut.topOffset < 0) {
        stickyContainer.classList.add("header-scrolled");
      } else {
        stickyContainer.classList.remove("header-scrolled");
      }
    }
  });
}

// sticky header on mobile
if (document.querySelector(".mobile-header-sticky") != null) {
  document.addEventListener("DOMContentLoaded", function (e) {
    const navbar = document.querySelector(".primary-mobile-nav");
    const mainNavbar = document.querySelector(".main-header-sticky");
    if (mainNavbar != null) {
      const headerHeight = mainNavbar.getBoundingClientRect().height;
    }
    window.addEventListener(
      "scroll",
      function (event) {
        var top = this.scrollY,
          left = this.scrollX;

        if (window.scrollY == 0) {
          if (navbar != null) {
            navbar.classList.add("position-relative");
            navbar.classList.remove("position-fixed");
            navbar.classList.remove("sticky-mobile");
            // navbar.classList.remove("fade-in");
          }
        }
      },
      false
    );
    const stickyNav = function (entries) {
      const [entry] = entries;
      if (!entry.isIntersecting) {
        //header
        navbar.classList.remove("position-relative");
        navbar.classList.add("position-fixed");
        navbar.classList.add("sticky-mobile");
        // navbar.classList.add("fade-in");
      } else {
        return;
      }
    };
    const headerObserver1 = new IntersectionObserver(stickyNav, {
      root: null,
      threshold: 0,
      rootMargin: "0px",
    });
    if (navbar != null) {
      headerObserver1.observe(navbar);
    }
  });
}